import type { SVGProps } from 'react';
const SvgFileList = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" viewBox="-0.5 -0.5 14 14" {...props}>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3.25 3.714H6.5M3.25 9.286H6.5M3.25 6.5h6.5M1.393.464h10.214s.929 0 .929.929v10.214s0 .929-.929.929H1.393s-.929 0-.929-.929V1.393s0-.929.929-.929" />
    </g>
  </svg>
);
export default SvgFileList;
